__turbopack_context__.v({
  "close": "filters-menu-module-scss-module__4Ofv1G__close",
  "overlay": "filters-menu-module-scss-module__4Ofv1G__overlay",
  "overlay--close": "filters-menu-module-scss-module__4Ofv1G__overlay--close",
  "overlay--open": "filters-menu-module-scss-module__4Ofv1G__overlay--open",
  "scroll-lock": "filters-menu-module-scss-module__4Ofv1G__scroll-lock",
  "submit": "filters-menu-module-scss-module__4Ofv1G__submit",
  "title": "filters-menu-module-scss-module__4Ofv1G__title",
  "wrapper": "filters-menu-module-scss-module__4Ofv1G__wrapper",
  "wrapper--close": "filters-menu-module-scss-module__4Ofv1G__wrapper--close",
  "wrapper--open": "filters-menu-module-scss-module__4Ofv1G__wrapper--open",
});
